import { Globals } from "../../globals/variables";
import { loadLib, loadLibTimeOut } from "../../utils/utils";


export const configWhatsapp = () => {


  const config = {
    mode: "widget",
    phoneNumber: "34683788765",
    message: "¡Hola! (no borres este mensaje) tu número de solicitud es el:",
    widget: {
      tooltip: {
        showAfterTime: 0,
        showPermanent: false,
        temporalTime: 5000,
        message: "Contacta por WhatsApp",
      },
      styles: {
        backgroundColor: "#25d366",
        svgColor: "#FFF",
        tootipBackgroundColor: "#25D366",
        tooltipTextColor: "#FFF",
        pulseAnimation: "rgba(37, 211, 101, 0.8)",
        widgetHeight: "10",
        widgetBottom: "5",
        widgetRight: "1"
      },
    },
    button: {
      message: "Hablemos por WhatsApp",
      styles: {
        backgroundColor: "#009900",
        hoverBackgroundColor: "#009900",
        svgColor: "#FFF",
        svgWidth: "30px",
        textColor: "#FFF",
        width: "250px",
        height: "38px",
        borderRadius: "0.5rem",
        fontSize: "18px",
      },
    },
  };
  return btoa(JSON.stringify(config));
};

const activarWhatsappD3A = () => {
  return new Promise((resolve) => {
    const urlsWhatsapp = [
      {
        url: "https://www.repsol.es/particulares/hogar/luz-y-gas/tarifas/",
        activacion: true,
      },
      {
        url: "https://qa-es.repsol.com/particulares/hogar/luz-y-gas/",
        activacion: true,
      },
      {
        url: "https://qa-es.repsol.com/particulares/hogar/luz-y-gas/tarifas/",
        activacion: true,
      },
      {
        url: "https://t.womtp.com/slider/c/walmeric/test_landing/repsol_whatsapp/dist/index.html",
        activacion: true,
      },
      {
        url: "http://localhost:9006/",
        activacion: true,
      },
      {
        url: "https://www.repsol.es/particulares/hogar/luz-y-gas/tarifas-luz/",
        activacion: true,
      },
      {
        url: "https://www.repsol.es/particulares/vehiculos/estaciones-de-servicio/promociones/duplica-tu-saldo-waylet/",
        activacion: true,
      },
      {
        url: "https://www.repsol.es/particulares/hogar/luz-y-gas/tarifas/tarifa-segunda-residencia/",
        activacion: true,
      },
      {
        url: "https://www.repsol.es/particulares/hogar/luz-y-gas/tarifas/tarifa-ahorro-plus/",
        activacion: true,
      },
      {
        url: "https://www.repsol.es/particulares/hogar/luz-y-gas/tarifas/tarifa-plana/",
        activacion: true,
      },
      {
        url: "https://www.repsol.es/particulares/hogar/luz-y-gas/tarifas/tarifa-10h-descuento/",
        activacion: true,
      },
      {
        url: "https://www.repsol.es/particulares/hogar/luz-y-gas/tarifas/plan-mixto/",
        activacion: true,
      },
      {
        url: "https://www.repsol.es/particulares/hogar/luz-y-gas/tarifas/tarifa-plana-luz-y-gas-natural/",
        activacion: true,
      },
      {
        url: "https://www.repsol.es/autonomos-y-empresas/soluciones/luz-y-gas/",
        activacion: true,
      }
     
      
    ];

    const currentUrl = window.location.href;

    const matchingUrlObject = urlsWhatsapp.find((urlObject) =>
      currentUrl.includes(urlObject.url)
    );

    if (matchingUrlObject) {
      resolve(matchingUrlObject.activacion);
    }

    resolve(false);
  });
};

export const getDevice = () => {
  return new Promise((resolve, reject) => {
    const agenteUsuario = navigator.userAgent.toLowerCase();

    const tiposDispositivos = {
      mobile: "Phone/ S.O Android.",
      mobile: "(iPhone, iPad, iPod)/ S.O iOS.",
      windows: "Desktop/Windows.",
      macintosh: "Macintosh (Mac)/S.O macOS.",
      linux: "Desktop/S.O Linux.",
    };

    const dispositivoDetectado = Object.entries(tiposDispositivos).find(
      ([dispositivo, descripcion]) => {
        const patronRegex = new RegExp(dispositivo, "i");
        return patronRegex.test(agenteUsuario);
      }
    );

    if (dispositivoDetectado) {
      resolve(dispositivoDetectado[0]);
    } else {
      resolve("mobile");
    }
  });
};

export const isAgentAvalaible = async () => {
  const myHeaders = new Headers();
  myHeaders.append("x-client-id", Globals.D3A.clientId);
  myHeaders.append("x-campaign-id", Globals.D3A.campaignId);

  const requestOptions = {
    method: "GET",
    headers: myHeaders,
    redirect: "follow",
  };

  const response = await fetch("https://d3a.walmeric.com/sio/api/v2/agents/available", requestOptions);
  return await response.json();
};



export const loadWhatsapp = async () => {
  const activarWhatsapp = await activarWhatsappD3A();
  const dispositivo = await getDevice();
  const agentAvalaible=await isAgentAvalaible()

  const activacionWhatsapp =
    activarWhatsapp && dispositivo == "mobile" ? true : false;

  if (activacionWhatsapp && agentAvalaible.available) {
    globalThis.clientId = Globals.D3A.clientId;
    globalThis.campaignId = Globals.D3A.campaignId;
    globalThis.idTagDelio = Globals.idTagD1C;
    globalThis.whatsappConfig = configWhatsapp();
    globalThis.phone = undefined;
    return loadLibTimeOut(
      "https://d3a.walmeric.com/whatsapp/bundle.js",
      Globals.idTagD1C
    );
  }else{
    console.info("Walmeric:Agentes no disponibles")
  }
};
